// Lives here rather than in src/components/Plans/utils/constants.ts so that
// App-level consumers (the toast notification component and the app-wide
// notification listeners) don't drag that 600+ line grid data file into the
// initial bundle.
export const TOAST_VARIANTS = {
  ERROR: 'error',
  SUCCESS: 'success',
  WARNING: 'warning',
}
